import React, { Fragment } from "react";
import styled from "styled-components";
import SideNav from "./SideNav";
import AccountMenu from "../Base/AccountMenu";

const Page = styled.div`
  display: flex;
`;

const PageTitleBar = styled.div`
  background: #fff;
  height: 67px;
  border-bottom: solid 1px #eaedf3;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 30px;
  position: relative;
`;

const PageTitle = styled.h1`
  font-size: 18px;
  font-weight: 500;
  color: #3e3f42;
`;

const PageContent = styled.div`
  padding: 30px;
`;

const PageContainer = styled.div`
  flex: 1;
  background: #fbfbfd;
`;

export default ({ title, children }) => (
  <Page>
    <SideNav />
    <PageContainer>
      <PageTitleBar>
        <PageTitle>{title}</PageTitle>
        <AccountMenu />
      </PageTitleBar>
      <PageContent>{children}</PageContent>
    </PageContainer>
  </Page>
);
